import { ProcessGeneral } from 'api/endpoints/processes';
import { FieldGeneral } from 'api/endpoints/processFields';
import { TmsConnectionDetails } from 'api/endpoints/tmsConnections';
import { EmailTemplate } from 'container/services/emailTemplates/IEmailTemplateRepo';

import { API_REQ_ACTION_TYPES } from '../actions';
import apiReqSagaCreator from '../apiReqSagaCreator';
import { ApiPaths, HTTP_METHODS } from '../constants';

const { REACT_APP_API_DOCUMENT_SERVICE: documentServiceUrl } = import.meta.env;

export type BarcodeType = 'code39' | 'code128' | 'codabar' | 'interleaved2of5';
export type AdditionalFieldType = 'barcode' | 'order_number' | 'doc_type';

export interface PrintRenderScenarioTruckmate {
  useLineId?: boolean;
  rebillEnabled?: boolean;
  rebillSkipDocTypes?: string;
  creditEnabled?: boolean;
}

// derived from api:src/models/print-render-scenario.go@PrintRenderScenario
export interface PrintRenderScenarioGeneral extends BaseEntity {
  process: ProcessGeneral;
  barcodeType: BarcodeType;
  isActive: boolean;
  withoutEmail: boolean;
  truckMate?: PrintRenderScenarioTruckmate;
  useSpanOrderNumbers?: boolean;
  tms: Nullable<TmsConnectionDetails>;
  predefinedFieldValue?: string;
  docTypeValue: string;
  additionalField: AdditionalFieldType;
  emailTemplatesSelectAll: boolean;
  enableDownloadDailyPrintBatch: boolean;
  attachSuccessDocsOnly: boolean;
  summaryNotificationEmailAddrs: string;
  printInvoices: boolean;
}

export type PrintRenderScenarioWithHypermedia = PrintRenderScenarioGeneral &
  WithHypermedia;

export interface PrintRenderScenarioDetails extends PrintRenderScenarioGeneral {
  barcodeField: FieldGeneral;
  orderSearchField: FieldGeneral;
  docTypeSearchField: FieldGeneral;
  sourceFileField: FieldGeneral;
  backupFileField: FieldGeneral;
  docFileSearchField: FieldGeneral;
  emailTemplates: EmailTemplate[];
  emailToField?: FieldGeneral;
  predefinedField?: FieldGeneral;
}
interface UploadFileData {
  file: FormData;
}

interface UpdateFileArgs extends UploadFileData {
  fileKey: string;
}
export type GetAllScenariosResult = DataWithTotal<PrintRenderScenarioGeneral>;
export type GetScenarioDetailsResult = PrintRenderScenarioDetails;
export type ActivateScenarioResult = unknown;
export type DeleteScenarioResult = unknown;
export type UpdateFileParams = UpdateFileArgs;
export type UpdateFileResult = unknown;

const PrintRender = {
  updateFile: apiReqSagaCreator<UpdateFileParams, UpdateFileResult>(
    API_REQ_ACTION_TYPES.PRINT_RENDER.UPLOAD_FILE,
    (args) => ({
      method: HTTP_METHODS.PUT,
      url: ApiPaths.printRender.file._(),
      data: args.file,
      params: {
        file_key: args.fileKey,
      },
      paramsSerializer: (params) =>
        Object.keys(params).reduce(
          (acc, key, idx) =>
            (acc += `${key}=${encodeURI(params[key])}${
              idx < Object.keys(params).length - 1 ? '&' : ''
            }`),
          ''
        ),
      baseURL: documentServiceUrl,
    })
  ),
};

export default PrintRender;
